// Allow-list of image formats guaranteed to render in the report engine (Jasper/ImageIO, Java 8)
// used by the fabrication-prototype request form. Single source of truth shared by the front guard
// (GeneralRequestForm.handleSubmit) and the <input type="file" accept="..."> UI filter
// (PrototypeRequestForm), mirroring the literal allow-list agreed with the sun backend pre-flight
// endpoint (story 47, decision D6: constant per repo, no setting).
export const RENDERABLE_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png']
export const RENDERABLE_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png']
export const RENDERABLE_IMAGE_FORMATS_LABEL = 'JPG, PNG'
export const RENDERABLE_IMAGE_INPUT_ACCEPT = 'image/jpeg,image/png,.jpg,.jpeg,.png'

// Validates the real selected file (MIME type and/or file name extension), not the <input accept>
// attribute: accept is a UI-only filter and can be bypassed (drag & drop, OS file dialog, or a
// browser that ignores it), so it must never be trusted as the actual barrier (V1, S10).
export const isRenderableImageFormat = (file) => {
  if (!(file instanceof File)) {
    return true
  }
  const mimeType = (file.type || '').toLowerCase()
  const fileName = (file.name || '').toLowerCase()
  const hasAllowedMimeType = RENDERABLE_IMAGE_MIME_TYPES.includes(mimeType)
  const hasAllowedExtension = RENDERABLE_IMAGE_EXTENSIONS.some((extension) => fileName.endsWith(extension))
  return hasAllowedMimeType || hasAllowedExtension
}
